import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import { Product as ProductType } from '../useOrderProducts'
import ProductImage from 'theme/atoms/ProductImage'

type Props = {
  product: ProductType
}

export default function Product(props: Props) {
  return (
    <Wrapper className="Product">
      <ProductImage
        img={props.product.imageUrl}
        size="s"
        alt={props.product.title}
      />
      <div className="info">
        <div className="title">{props.product.title}</div>
        <div className="subtitle">{props.product.subtitle}</div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  gap: ${theme.spacing('m')};

  > .ProductImage {
    box-sizing: border-box;
    width: 90px;
    height: 90px;
    background: white;
    padding: 10px;
    border: 1px solid ${theme.colors.shade.b5};
  }

  > .info {
    .title {
      ${theme.ty('rc-s', 'bold', 'rc-l')}
      margin-bottom: ${theme.spacing('xxs')};
    }
    .subtitle {
      ${theme.ty('r-xs', null, 'r-s')}
    }
  }
`
